var _rect, _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3DZone1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 305,
    width: 103.87,
    height: 23.51,
    rx: 11.755,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M545.033 322.255V321.085L551.152 312.13H544.981V310.619H553.3V311.789L547.18 320.744H553.351V322.255H545.033ZM565.594 316.437C565.594 317.679 565.366 318.747 564.912 319.641C564.457 320.532 563.834 321.217 563.042 321.698C562.255 322.175 561.359 322.414 560.355 322.414C559.347 322.414 558.448 322.175 557.656 321.698C556.868 321.217 556.247 320.53 555.792 319.636C555.338 318.742 555.111 317.675 555.111 316.437C555.111 315.194 555.338 314.128 555.792 313.238C556.247 312.344 556.868 311.658 557.656 311.181C558.448 310.7 559.347 310.46 560.355 310.46C561.359 310.46 562.255 310.7 563.042 311.181C563.834 311.658 564.457 312.344 564.912 313.238C565.366 314.128 565.594 315.194 565.594 316.437ZM563.855 316.437C563.855 315.49 563.702 314.692 563.395 314.045C563.092 313.393 562.675 312.901 562.145 312.567C561.618 312.23 561.022 312.062 560.355 312.062C559.684 312.062 559.086 312.23 558.559 312.567C558.033 312.901 557.616 313.393 557.309 314.045C557.006 314.692 556.855 315.49 556.855 316.437C556.855 317.384 557.006 318.183 557.309 318.835C557.616 319.482 558.033 319.975 558.559 320.312C559.086 320.645 559.684 320.812 560.355 320.812C561.022 320.812 561.618 320.645 562.145 320.312C562.675 319.975 563.092 319.482 563.395 318.835C563.702 318.183 563.855 317.384 563.855 316.437ZM577.655 310.619V322.255H576.041L570.126 313.721H570.018V322.255H568.262V310.619H569.887L575.808 319.164H575.916V310.619H577.655ZM580.696 322.255V310.619H587.991V312.13H582.451V315.675H587.61V317.181H582.451V320.744H588.059V322.255H580.696ZM599.786 310.619V322.255H598.025V312.38H597.957L595.173 314.198V312.516L598.076 310.619H599.786Z",
    fill: "#2E3838"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 572.935,
    cy: 395.51,
    r: 25.3,
    stroke: "white",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.935,
    cy: 395.51,
    r: 38,
    stroke: "white",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.935,
    cy: 395.51,
    r: 13.65,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DZone1);
export default __webpack_public_path__ + "static/media/3d_zone_1.c82c9daf18bcd9730268f1f03087c5a7.svg";
export { ForwardRef as ReactComponent };